var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getStackedBarRadiusFromEntry } from '@web/utility/charts';
import { Cell } from 'recharts';
var StackedBarCell = Cell;
export function renderStackedBarCells(_a) {
    var chartData = _a.chartData, stackDataKeys = _a.stackDataKeys, segmentIndex = _a.segmentIndex, getCellProps = _a.getCellProps, _b = _a.keyPrefix, keyPrefix = _b === void 0 ? 'stacked-bar-cell' : _b;
    return chartData.map(function (entry, dataIndex) { return (_jsx(StackedBarCell, __assign({ radius: getStackedBarRadiusFromEntry(entry, stackDataKeys, segmentIndex) }, getCellProps === null || getCellProps === void 0 ? void 0 : getCellProps(entry, dataIndex)), "".concat(keyPrefix, "-").concat(dataIndex))); });
}
